import service from "./index";

/**
 * 初始化数据
 */
export function home (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/initdata",
    data: data
  })
}

/**
 * 文章列表
 */
export function articlelist (data) {

  return service.request({
    method: "post",
    url: "/newedition/institute/articlelist",
    data: data
  })
}

/**
 * 点赞
 */
export function like (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/like",
    data: data
  })
}

/**
 * 收藏
 */
export function collections (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/collections",
    data: data
  })
}

/**
 * 取消收藏
 */
export function cancelcollections (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/cancelcollections",
    data: data
  })
}

/**
 * 换一批
 */
export function changebatch (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/changebatch",
    data: data
  })
}

/**
 * 研究所详情
 */
export function detail (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/detail",
    data: data
  })
}

/**
 * 投票
 */
export function savevote (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/savevote",
    data: data
  })
}

/**
 * 广告
 */
export function adList (data) {
  return service.request({
    method: "post",
    url: "/newedition/common/adlist",
    data: data
  })
}

/**
 * 浏览记录
 */
export function instituteSee (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/historylist",
    data: data
  })
}

/**
 * 保存打赏
 */
export function savereward (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/savereward",
    data: data
  })
}

/**
 * 官网轮播图
 */
export function banner (data) {
  return service.request({
    method: "post",
    url: "/yx/appbanner",
    data: data
  })
}

/**
 * 保存评论
 */
export function savecomment (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/savecomment",
    data: data
  })
}

/**
 * 评论数据
 */
export function commentlist (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/commentlist",
    data: data
  })
}

/**
 * 评论点赞
 */
export function commentlike (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/commentlike",
    data: data
  })
}

/**
 * 获取文章类型
 */
export function articleType (data) {
  return service.request({
    method: "post",
    url: "/newedition/common/contentattr",
    data: data
  })
}

/**
 * 保存到草稿箱
 */
export function savedraft (data) {
  return service.request({
    method: "post",
    url: "/newedition/common/savedraft",
    data: data
  })
}

/**
 * 发布文章
 */
export function publisharticle (data) {
  return service.request({
    method: "post",
    url: "/newedition/institute/publishcontent",
    data: data
  })
}

/**
 * 草稿箱详情
 */
export function daftdetail (data) {
  return service.request({
    method: "post",
    url: "/newedition/common/daftdetail",
    data: data
  })
}

/**
 * 研究所搜索
 */
export function institutesearch (data) {
  return service.request({
    method: "post",
    url: "/newedition/common/institutesearch",
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js